import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Link } from "react-router-dom";
import { updatedataprescriptionobjects, updatedataremotestar, updatedataremotefittingobjects } from "../../Api/iron"
import { proscriptionhistory, getPrescription } from "../../Api/prescriptionApis"
import TabFormData from "../DashboardComponents/TabsData/TabFormData";
import TabNotesData from "../DashboardComponents/TabsData/TabNotesData";
import AccordionData from "../clubfittingupdate/AccordionData";
import { FaAngleUp, FaStar } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import PrescriptionLeft from "../Prescription/PrescriptionLeft";
import BuildAccordion from "./BuildAccordion";
import BuildSheetLeft from "./BuildSheetLeft";
import BuildStation from "./BuildStation";
import BuildStationLeft from "./BuildStationLeft";
import LeftScript4 from "../Prescription/LeftScript4";
import { FaCheck } from "react-icons/fa";

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};


const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};

function PrescTab2({ project_id, project_step = "history", status, currentpagename, buildsheets, ondeleteChange, allmodels, remotefittingdataofdata, prescriptioncalc, SinglePrescription, allMakeData, setoptimaldataCall, studioshow }) {


    const [historydata, setHistorydata] = useState([]);
    const [formData, setFormData] = useState(initData);
    const [prescription, setPrescription] = useState(0);
    const [current_project_step, setCurrent_project_step] = useState(project_step);
    const [prescriptiondata, setPrescriptiondata] = useState(initialPrescriptionState);

    const [prescriptionStatus, setPrescriptionStatus] = useState('prescribed');

    const getDataById = () => {
        // getremoteInquirydataApi({ id: project_id }).then((res) => {
        //     console.log("calling apiii", "5");
        //     if (res?.code === 200) {
        //         const userData = res.data.data;
        //         console.log("userData", userData);
        //         setFormData(userData);
        //         manageResult(userData.remotefittingdata);
        //     } else {
        //         alert(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // })

        if (remotefittingdataofdata) {
            setFormData(remotefittingdataofdata);
            manageResult(remotefittingdataofdata?.remotefittingdata);
        }
    }


    const [resultoutput, setResultoutput] = useState({
        white: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        black: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        blue: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        pink: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        purple: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        red: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        orange: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        green: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
    });

    const manageResult = (result) => {

    }

    useEffect(() => {

    }, [resultoutput]);



    const getbuildsheetscript = () => {

        if (prescriptioncalc) {
            setPrescriptiondata(prescriptioncalc);
            setPrescriptionStatus(prescriptioncalc?.status)
        }
    }

    const getData = () => {

        switch (current_project_step) {
            case "history":
                getDataById();
                getprescriptionDataById();
                getbuildsheetscript();
                break;
            case "prescription":
                getDataById();
                getprescriptionDataById();
                getbuildsheetscript();
                break;
            case "buildsheet":
                getbuildsheetscript();
                break;
            case "stagestation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetscript();
                break;
            case "buildstation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetscript();
                break;
            case "shipstation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetscript();
                break;
            default:
                getDataById();
                getprescriptionDataById();
                getbuildsheetscript();
                break;
        }
    }

    const getprescriptionDataById = () => {
        if (SinglePrescription) {
            setPrescription(SinglePrescription);
        }
    }

    useEffect(() => {
        getData();
    }, [project_id])


    const [isTabVisible, setIsTabVisible] = useState(false);

    const [makedata, setMakeData] = useState([]);
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 991) {
                setIsTabVisible(true);
            } else {
                setIsTabVisible(false);
            }
        };

        // Set the initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const [optimalHeadsobject, setOptimalHeadsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalShaftsobject, setOptimalShaftsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [optimalGripsobject, setOptimalGripsobject] = useState({
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    });

    const [head1, setHead1] = useState('');
    const [head2, setHead2] = useState('');
    const [head3, setHead3] = useState('');

    const [optimalHeads, setOptimalHeads] = useState(0);
    const [optimalShafts, setOptimalShafts] = useState(0);
    const [optimalGrips, setOptimalGrips] = useState(0);

    const [Shaft1, setShaft1] = useState('');
    const [Shaft2, setShaft2] = useState('');
    const [Shaft3, setShaft3] = useState('');

    const [Grip1, setGrip1] = useState('');
    const [Grip2, setGrip2] = useState('');
    const [Grip3, setGrip3] = useState('');

    const [allmodelsdata, setAllmodelsdata] = useState([]);

    useEffect(() => {
        if (allmodels && allmodels.length > 0 && allmodelsdata && allmodelsdata.length === 0) {
            setAllmodelsdata(allmodels);
        }
    }, [allmodels]);


    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        const filtermakedata = allMakeData && allMakeData.filter((item) => item.item_type_id.includes(id));
        if (id === 4) {
            setMakeData(filtermakedata);
        }
        if (id === 7) {
            setShaftData(filtermakedata);
        }
        if (id === 8) {
            setGripData(filtermakedata);
        }
    }

    useEffect(() => {
        if (allMakeData) {
            getmakedata(4);
            getmakedata(7);
            getmakedata(8);
        }
    }, [allMakeData]);

    const handleNestedChange = (section, option, subField, value) => {
        const optionKey = `option${option}`;
        let type_id = "";
        switch (section) {
            case "optimalHeads":
                type_id = "4";
                break;
            case "optimalShafts":
                type_id = "7";
                break;
            case "optimalGrips":
                type_id = "8";
                break;
            default:
                break;
        }

        // Filter the models from allmodels array
        const filteredModels = allmodelsdata.filter(model =>
            model.Make === value && model.type_id === type_id
        );

        // Set the data based on section, subField, and option
        if (filteredModels.length > 0) {
            const data = filteredModels;

            if (section === 'optimalHeads') {
                switch (option) {
                    case 1:
                        setHead1(data);
                        break;
                    case 2:
                        setHead2(data);
                        break;
                    case 3:
                        setHead3(data);
                        break;
                    default:
                        break;
                }
            }

            if (section === 'optimalShafts') {
                switch (option) {
                    case 1:
                        setShaft1(data);
                        break;
                    case 2:
                        setShaft2(data);
                        break;
                    case 3:
                        setShaft3(data);
                        break;
                    default:
                        break;
                }
            }

            if (section === 'optimalGrips') {
                switch (option) {
                    case 1:
                        setGrip1(data);
                        break;
                    case 2:
                        setGrip2(data);
                        break;
                    case 3:
                        setGrip3(data);
                        break;
                    default:
                        break;
                }
            }

            const updateData = (setFunction, currentData) => {
                setFunction(prevData => ({
                    ...prevData,
                    [optionKey]: { // Update the correct option (option1, option2, option3)
                        ...prevData[optionKey],
                        [subField]: value // Update the specific field (make or model)
                    }
                }));
            };

            // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
            if (section === 'optimalHeads') {
                updateData(setOptimalHeadsobject, optimalHeadsobject);
            } else if (section === 'optimalShafts') {
                updateData(setOptimalShaftsobject, optimalShaftsobject);
            } else if (section === 'optimalGrips') {
                updateData(setOptimalGripsobject, optimalGripsobject);
            }
        } else {
            console.log("");
        }
    };


    const handleNestedChangeModel = (section, option, subField, value) => {
        const optionKey = `option${option}`;

        const updateData = (setFunction, prevData) => {
            const updatedData = {
                ...prevData,
                [optionKey]: { // Update the correct option (option1, option2, option3)
                    ...prevData[optionKey],
                    [subField]: value // Update the specific field (make or model)
                }
            };

            setFunction(updatedData); // Set the updated data to state
            updatedataremotefitting(section, updatedData); // Pass the updated data to the function
        };

        // Update the correct section (optimalHeads, optimalShafts, or optimalGrips)
        if (section === 'optimalHeads') {
            updateData(setOptimalHeadsobject, optimalHeadsobject);
        } else if (section === 'optimalShafts') {
            updateData(setOptimalShaftsobject, optimalShaftsobject);
        } else if (section === 'optimalGrips') {
            updateData(setOptimalGripsobject, optimalGripsobject);
        }
    };

    const updatedataremotefitting = (type, object) => {
        const data = {
            type: type,
            data: JSON.stringify(object),
            project_id: project_id
        }
        updatedataremotefittingobjects(data).then((res) => {
            // console.log("calling api", "1");
            if (res?.code === 200) {
                const buildsheetData = res.data.data
            } else {
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }


    useEffect(() => {
        if (remotefittingdataofdata?.optimalHeads) {
            setOptimalHeadsobject(prevState => ({
                ...prevState, // Preserve any existing data
                ...remotefittingdataofdata.optimalHeads // Update with new data
            }));
            //first convert to integer 
            setOptimalHeads(Number(remotefittingdataofdata?.optimalHeadsStar));
        }

        if (remotefittingdataofdata?.optimalShafts) {
            setOptimalShaftsobject(prevState => ({
                ...prevState,
                ...remotefittingdataofdata.optimalShafts
            }));
            setOptimalShafts(Number(remotefittingdataofdata?.optimalShaftsStar));
        }

        if (remotefittingdataofdata?.optimalGrips) {
            setOptimalGripsobject(prevState => ({
                ...prevState,
                ...remotefittingdataofdata.optimalGrips
            }));
            setOptimalGrips(Number(remotefittingdataofdata?.optimalGripsStar));
        }
    }, [remotefittingdataofdata]);


    useEffect(() => {
        if (allmodelsdata.length > 0) {
            handleNestedChange('optimalHeads', 1, 'make', remotefittingdataofdata?.optimalHeads?.option1?.make);
            handleNestedChange('optimalHeads', 2, 'make', remotefittingdataofdata?.optimalHeads?.option2?.make);
            handleNestedChange('optimalHeads', 3, 'make', remotefittingdataofdata?.optimalHeads?.option3?.make);

            handleNestedChange('optimalShafts', 1, 'make', remotefittingdataofdata?.optimalShafts?.option1?.make);
            handleNestedChange('optimalShafts', 2, 'make', remotefittingdataofdata?.optimalShafts?.option2?.make);
            handleNestedChange('optimalShafts', 3, 'make', remotefittingdataofdata?.optimalShafts?.option3?.make);

            handleNestedChange('optimalGrips', 1, 'make', remotefittingdataofdata?.optimalGrips?.option1?.make);
            handleNestedChange('optimalGrips', 2, 'make', remotefittingdataofdata?.optimalGrips?.option2?.make);
            handleNestedChange('optimalGrips', 3, 'make', remotefittingdataofdata?.optimalGrips?.option3?.make);
        }

    }, [allmodelsdata]);

    const handleChange = (type, value) => {

        if (type === 'optimalHeads') {
            setOptimalHeads(value);
        }

        if (type === 'optimalShafts') {
            setOptimalShafts(value);
        }

        if (type === 'optimalGrips') {
            setOptimalGrips(value);
        }

        const data = {
            type: type,
            data: value,
            project_id: project_id
        }
        updatedataremotestar(data).then((res) => {
            // console.log("calling api", "1");
            if (res?.code === 200) {
                const buildsheetData = res.data.data
                if (type === 'optimalHeads') {
                    setoptimaldataCall(optimalHeadsobject, type);
                }
                if (type === 'optimalShafts') {
                    setoptimaldataCall(optimalShaftsobject, type);
                }
                if (type === 'optimalGrips') {
                    setoptimaldataCall(optimalGripsobject, type);
                }
            } else {
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })

    }

    return (
        <>
            <div className="tab-container tab-club-fitting">
                <Tabs
                    defaultActiveKey="script"
                    id="uncontrolled-tab-example"
                    className="club-fitting-tab new_mobile_tab tab-wrapper"
                >

                    <Tab eventKey="script" title="Script">
                        <LeftScript4 status={status} project_id={project_id} allMakeData={allMakeData} remortFittingFormData={remotefittingdataofdata} studioshow={studioshow}/>
                    </Tab>


                    <Tab eventKey="results" title="Optimals">
                        <div className="accordion-section">
                            <div className="tab-box-section mb-4">
                                <div className="">
                                    <div className="club-fitting-card black_box">
                                        <div className="gab_title">
                                            <div class="gab_text"><h5>Optimal Heads</h5></div>
                                            <div className="collapsed">
                                                {/* <div className={`head_check ${optimalHeadsobject?.option1?.make && optimalHeadsobject?.option1?.model &&
                                                    optimalHeadsobject?.option2?.make && optimalHeadsobject?.option2?.model &&
                                                    optimalHeadsobject?.option3?.make && optimalHeadsobject?.option3?.model
                                                    ? 'active' : ''
                                                    }`}>
                                                    <FaCheck />
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group prescription-note presc-tab2">
                                        <div className="row mb-3 align-items-center">
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalHeads === 1 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalHeads", 1)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalHeadsobject?.option1?.make} onChange={(e) => handleNestedChange('optimalHeads', 1, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Make</option>
                                                    {makedata && makedata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalHeadsobject?.option1?.model} onChange={(e) => handleNestedChangeModel('optimalHeads', 1, 'model', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Model</option>
                                                    {head1 && head1.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row mb-3 align-items-center">
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalHeads === 2 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalHeads", 2)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalHeadsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalHeads', 2, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value={0}>Make</option>
                                                    {makedata && makedata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalHeadsobject?.option2?.model} onChange={(e) => handleNestedChangeModel('optimalHeads', 2, 'model', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value={0}>Model</option>
                                                    {head2 && head2.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row mb-3 align-items-center">
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalHeads === 3 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalHeads", 3)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalHeadsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalHeads', 3, 'make', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value={0}>Make</option>
                                                    {makedata && makedata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalHeadsobject?.option3?.model} onChange={(e) => handleNestedChangeModel('optimalHeads', 3, 'model', e.target.value)} className="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value={0}>Model</option>
                                                    {head3 && head3.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="tab-box-section mb-4">
                                <div className="">
                                    <div className="club-fitting-card black_box">
                                        <div className="gab_title">
                                            <div class="gab_text"><h5>Optimal Shafts</h5></div>
                                            <div className="collapsed">
                                                {/* <div className={`head_check ${optimalShaftsobject?.option1?.make && optimalShaftsobject?.option1?.model &&
                                                    optimalShaftsobject?.option2?.make && optimalShaftsobject?.option2?.model &&
                                                    optimalShaftsobject?.option3?.make && optimalShaftsobject?.option3?.model
                                                    ? 'active' : ''
                                                    }`}>
                                                    <FaCheck />
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group prescription-note presc-tab2">
                                        <div className="row mb-3 align-items-center">
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalShafts === 1 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalShafts", 1)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalShaftsobject?.option1?.make} onChange={(e) => handleNestedChange('optimalShafts', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Make</option>
                                                    {shaftdata && shaftdata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalShaftsobject?.option1?.model} onChange={(e) => handleNestedChangeModel('optimalShafts', 1, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Model</option>
                                                    {Shaft1 && Shaft1.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalShafts === 2 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalShafts", 2)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalShaftsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalShafts', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Make</option>
                                                    {shaftdata && shaftdata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalShaftsobject?.option2?.model} onChange={(e) => handleNestedChangeModel('optimalShafts', 2, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Model</option>
                                                    {Shaft2 && Shaft2.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalShafts === 3 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalShafts", 3)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalShaftsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalShafts', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Make</option>
                                                    {shaftdata && shaftdata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                {/* <select style={{textTransform:"capitalize"}} disabled={prescriptionStatus === "purchased"} value={optimalShaftsobject?.option3?.model} onChange={(e) => handleNestedChangeModel('optimalShafts', 3, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Model</option>
                                                    {Shaft3 && Shaft3.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select> */}
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalShaftsobject?.option3?.model || ""} onChange={(e) => handleNestedChangeModel('optimalShafts', 3, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Model</option>
                                                    {Shaft3 && Shaft3.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-box-section mb-4">
                                <div className="">
                                    <div className="club-fitting-card black_box">
                                        <div className="gab_title">
                                            <div class="gab_text"><h5>Optimal Grips</h5></div>
                                            <div className="collapsed">
                                                {/* <div className={`head_check ${optimalGripsobject?.option1?.make && optimalGripsobject?.option1?.model &&
                                                    optimalGripsobject?.option2?.make && optimalGripsobject?.option2?.model &&
                                                    optimalGripsobject?.option3?.make && optimalGripsobject?.option3?.model
                                                    ? 'active' : ''
                                                    }`}>
                                                    <FaCheck />
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group prescription-note presc-tab2">
                                        <div className="row mb-3 align-items-center">
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalGrips === 1 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalGrips", 1)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalGripsobject?.option1?.make} onChange={(e) => handleNestedChange('optimalGrips', 1, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Make</option>
                                                    {gripdata && gripdata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalGripsobject?.option1?.model} onChange={(e) => handleNestedChangeModel('optimalGrips', 1, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Model</option>
                                                    {Grip1 && Grip1.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalGrips === 2 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalGrips", 2)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalGripsobject?.option2?.make} onChange={(e) => handleNestedChange('optimalGrips', 2, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Make</option>
                                                    {gripdata && gripdata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalGripsobject?.option2?.model} onChange={(e) => handleNestedChangeModel('optimalGrips', 2, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Model</option>
                                                    {Grip2 && Grip2.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <label className="col-2 col-sm-2" style={{ marginTop: '-15px', marginRight: '-30px' }}>
                                                <svg stroke="currentColor" style={{
                                                    opacity: prescriptionStatus === "purchased" ? 0.5 : 1,
                                                    pointerEvents: prescriptionStatus === "purchased" ? 'none' : 'auto'
                                                }} fill={`${optimalGrips === 3 ? '#aee750' : '#404650'}`} onClick={() => handleChange("optimalGrips", 3)} strokeWidth="0" viewBox="0 0 576 512" height="37" width="37" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"></path>
                                                </svg>
                                            </label>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalGripsobject?.option3?.make} onChange={(e) => handleNestedChange('optimalGrips', 3, 'make', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Make</option>
                                                    {gripdata && gripdata.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.brand_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-5 col-sm-5 mb-3">
                                                <select style={{ textTransform: "capitalize" }} disabled={prescriptionStatus === "purchased"} value={optimalGripsobject?.option3?.model} onChange={(e) => handleNestedChangeModel('optimalGrips', 3, 'model', e.target.value)} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                                    <option value="" disabled>Model</option>
                                                    {Grip3 && Grip3.map((item) => (
                                                        <option value={item._id} key={item._id}>{item.ModelName}</option>
                                                    ))}
                                                </select>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>

                    <Tab eventKey="client" title="Client">
                        <div className="tab-box-section">
                            <TabFormData project_id={project_id} remortFittingFormData={remotefittingdataofdata} />
                        </div>
                    </Tab>

                    <Tab eventKey="notes" title="Notes">
                        <TabNotesData project_id={project_id} />
                    </Tab>
                </Tabs>
            </div>
        </>
    );
}

export default PrescTab2;